import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { postListExcerpt } from "../../utils/blogExcerpt";
import PostImage from "./PostImage";
import { getDateLocale } from "../../utils/locale";

function BlogCard({ post }) {
    const { t } = useTranslation();
    const date = new Date(post.published_at || post.created_at).toLocaleDateString(getDateLocale(), {
        year: "numeric",
        month: "long",
        day: "numeric",
    });

    return (
        <motion.div
            whileHover={{ y: -6, scale: 1.01 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
            className="h-full"
        >
            <Link to={`/blog/${post.slug}`} className="blog-card h-full">
                <div className="blog-card-img-wrap">
                    <PostImage
                        src={post.featured_image_url}
                        seed={post.id}
                        alt={post.title}
                        className="blog-card-img"
                    />
                </div>

                <div className="blog-card-content">
                    <div className="blog-card-meta">
                        <span className="blog-card-date">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
                                <path fillRule="evenodd" d="M5.75 2a.75.75 0 01.75.75V4h7V2.75a.75.75 0 011.5 0V4h.25A2.75 2.75 0 0118 6.75v8.5A2.75 2.75 0 0115.25 18H4.75A2.75 2.75 0 012 15.25v-8.5A2.75 2.75 0 014.75 4H5V2.75A.75.75 0 015.75 2zm-1 5.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H4.75z" clipRule="evenodd" />
                            </svg>
                            {date}
                        </span>
                    </div>

                    <h3 className="blog-card-title">{post.title}</h3>
                    <p className="blog-card-excerpt">
                        {postListExcerpt(post) || t("blog.noDescription")}
                    </p>

                    <div className="blog-card-readmore">
                        {t("blog.readMore")}
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
                            <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                        </svg>
                    </div>
                </div>
            </Link>
        </motion.div>
    );
}

export default BlogCard;
